module.exports = __webpack_public_path__ + "static/media/Payment History_active_Blue.82df0239.svg";